import React from "react";
import './Sitemap.css'
import { Link } from "react-router-dom";

const Sitemap = () => {
  return (
    <div className="main-site">
      <div className="second-site">
        <div className="site1">
          <p>Sitemap</p>
          <div>
            <p className="s2">Swajit Engineering Pvt.Ltd.>Sitemap</p>
          </div>
        </div>
        <div className="site-content">
            <ul>
                <li><Link to="/site-conveyor">Conveyor Chain</Link></li>
                <li><Link to="/site-simplex">Simplex, Duplex, Triplex Transmission Chain</Link></li>
                <li><Link to="/site-bucket">Bucket Elevator Chain</Link></li>
                <li><Link to="/site-scrapper">Scrapper Reclaimer Chain</Link></li>
                <li><Link to="/site-drag">Drag/Flow Conveyor Chain</Link></li>
                <li><Link to="/site-coke">Coke Oven Drag Chain</Link></li>
                <li><Link to="/site-palm">Palm & Soyabean Oil Conveyor Chain</Link></li>
                <li><Link to="/site-steel">Steel Industry Chain</Link></li>
                <li><Link to="/site-power">Power Industry Chain</Link></li>
                <li><Link to="/site-paper">Paper Industry Conveyor Chain</Link></li>
                <li><Link to="/site-chemical">Chemical & fertilizer Conveyor Chain</Link></li>
                <li><Link to="/site-heavy">Heavy Duty Conveyor Chain</Link></li>
            </ul>
        </div>

      </div>
    </div>
  );
};

export default Sitemap;
